import { isDevMode } from '@angular/core';
import { parsePrefixes } from './parse-prefixes';

const hostname = isDevMode() ? 'dev.coin.siemens-energy.com' : window.location.hostname;
const origin = `https://${hostname}`;
const apiBaseUrl = `${origin}/ecs`;

const { featurePrefix, stagePrefix } = parsePrefixes(hostname);
const adminBaseUrl = `https://${featurePrefix}admin.${stagePrefix}coin.siemens-energy.com`;
const cosmosBaseUrl = `https://${featurePrefix}cosmos.${stagePrefix}coin.siemens-energy.com`;
const importerBaseUrl = `https://${featurePrefix}importer.${stagePrefix}coin.siemens-energy.com`;
export const environment = {
  production: true,
  coinAssetsPath: `https://assets.${hostname}`,
  coinImagePath: `https://images.${featurePrefix}${stagePrefix}coin.siemens-energy.com/`,
  authentication: {
    scopes: 'openid profile email',
    issuer: 'https://login.microsoftonline.com/common/v2.0/'
  },
  customerAuthentication: {
    callbackUrl: `${origin}/auth/callback`,
    clientId: '13d3841f-1c57-4069-be8a-36d3f759786b'
  },
  adminAuthentication: {
    callbackUrl: `${adminBaseUrl}/auth/callback`,
    clientId: '13d3841f-1c57-4069-be8a-36d3f759786b'
  },
  cosmosAuthentication: {
    callbackUrl: `${cosmosBaseUrl}/auth/callback`,
    clientId: '13d3841f-1c57-4069-be8a-36d3f759786b'
  },
  importerAuthentication: {
    enabled: true,
    callbackUrl: `${importerBaseUrl}/auth/callback`,
    clientId: '13d3841f-1c57-4069-be8a-36d3f759786b'
  },
  storybookAuthentication: {
    clientId: '13d3841f-1c57-4069-be8a-36d3f759786b',
    callbackUrl: `${origin}/login/auth/callback`
  },
  baseButtonColorLight: true,
  api: {
    baseUrl: apiBaseUrl,
    letterServiceUrl: `${apiBaseUrl}/letterservice`,
    pdfCreationService: `${origin}/api/serverless/pdf_creation_service`,
    documentsUrl: `${origin}/api/serverless/document_service`,
    exportDownloadServiceUrl: `${origin}/api/serverless/file_download_service`,
    imagesService: `${origin}/api/serverless/image_service/`,
    cmsService: `${origin}/api/serverless/cms_service/`,
    cmsServiceProd: `https://coin.siemens-energy.com/api/serverless/cms_service/`,
    cosmosSearchService: `${origin}/api/serverless/search_service/`,
    importerService: `${origin}/api/serverless/importer_service/api/v1`,
    storageService: `${origin}/api/serverless/storage_service`
  },
  device: 'desktop',
  cmsContentProdBucketCloudfront: 'https://cms.coin.siemens-energy.com/',
  cmsContentStageBucketCloudfront: `https://cms.${hostname}/`,
  documentDownloadCloudfront: `https://download-documents.${hostname}/`,
  type: 'Dev',
  featurePrefix,
  setProfilePictureEndpoint: 'https://profile.hrs.siemens.cloud/',
  adminUrl: `${adminBaseUrl}/`,
  customerUrl: `${origin}/`,
  cosmosUrl: `${cosmosBaseUrl}/`,
  importerTableLimit: 25,
  subscriptionIntervalInMs: 5000,
  icon: 'code',
  avatureJobUrl: 'http://siemensenergy.avature.net/internalcareers/FolderDetail/',
  helpdeskUrl:
    'https://siemensenergy.service-now.com/sp?id=sc_cat_item&sys_id=29cfcd841bac061080ff62406b4bcbf1&referrer=popular_items',
  paolaUrl: 'https://dev.odpa.siemens-energy.com/applications/orgcode-checker',
  chatBot: {
    runtimeUrl: `https://app.ai.mira.siemens-energy.com/projects/coin/agents/uxe4-ktwr/stages/dev/copilotkit/angular`,
    licenseKey: 'ck_pub_1c91915e2ee69779659fb42de5bf414a'
  }
};
